module.exports = __webpack_public_path__ + "img/curved-rail-vertical-left-bottom-metals.891b8814.png";